<template>
  <div>
    <Card>
      <TablePaginate
        :columns="columns"
        :data="function_payments"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { paymentChinese } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: i18n.t('pages_balance_transaction_index_175'),
          width: 180,
          align: 'center',
          key: 'function_paymentable_price'
        },
        {
          title: i18n.t('pages_payments_index_710'),
          width: 180,
          align: 'center',
          key: 'function_paymentable_type',
          // render: (h, params) => {
          //   return podStatus(h, params.row.payment_method)
          // }
        },
        {
          title: i18n.t('pages_payments_index_711'),
          width: 180,
          align: 'center',
          key: 'name'
        },
        {
          title: i18n.t('pages_bills_index_198'),
          width: 180,
          align: 'center',
          key: 'status',
          render: (h, params) => {
            return paymentChinese(h, params.row.status)
          }
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at',
          width: 200,
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.index()
  },
  computed: {
    ...mapGetters('function_payment', ['function_payments', 'function_payment', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('function_payment', ['index']),
    ...mapMutations('function_payment', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page })
      this.index()
    }
  }
}
</script>
